import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { AlignType } from 'common/types/styleTypes'
import { useHeadingFontSize } from './use-heading-font-size'
import { useHeadingLineHeight } from './use-heading-line-height'
import { useHeadingTextAlign } from './use-heading-text-align'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { useHeadingLetterSpacing } from './use-heading-letter-spacing'
import { useFontFamily } from '../use-typography/use-font-family'
import { useHeadingFontFamily } from './use-heading-font-family'
import { useHeadingFontStyle } from './use-heading-font-style'
import { useHeadingFontWeight } from './use-heading-font-weight'

export const useHeadingTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
} = {}) => {
  const returnUseFontFamily = useHeadingFontFamily({
    fontFamily,
    mobileFontFamily,
  })

  const returnUseHeadingFontStyle = useHeadingFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseHeadingFontWeight = useHeadingFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseFontSize = useHeadingFontSize({
    fontSize,
    mobileFontSize,
  })

  const returnUseLineHeight = useHeadingLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
  })

  const returnUseTextAlign = useHeadingTextAlign({
    textAlign,
    mobileTextAlign,
  })

  const returnUseLetterSpacing = useHeadingLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
  })

  return {
    ...returnUseFontSize,
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    ...returnUseFontFamily,
    ...returnUseHeadingFontStyle,
    ...returnUseHeadingFontWeight,
  }
}
